export const SET_CREDENTIALS = "USERS_SET_CREDENTIALS";
export const REMOVE_CREDENTIALS = "USERS_REMOVE_CREDENTIALS";
export const RESET_USERS = 'USERS_RESET_USERS'; 
export const SET_USERS = 'USERS_SET_USERS'; 
export const RESET_USER = 'USERS_RESET_USER'; 
export const SET_ERROR = 'USERS_SET_ERROR';
export const CHANGE_ATTR = 'USERS_CHANGE_ATTR';
export const SET_USER = 'USERS_SET_USER';